import { EtrAPI } from './core/src/etr-api-client';

/**
 * Prefetch HP services data before hydrating the client, set a max wait time since HPService is slow
 * @param {*} initialStore 
 * @param {*} maxWait 
 */
const prefetchHPService = (initialStore, maxWait=1000) => {
     //check for prefetch price hint
     const { productData={} } = initialStore;
     const { productInfo={} } = productData;
     const { productPrices={} } = productInfo;
     const {prefetchPrice=[] } = productPrices;
     let priceIds = []
     if(prefetchPrice && prefetchPrice.length ){
         priceIds = prefetchPrice;
         //delete prefetch price hint
         delete initialStore.productData.productInfo.productPrices.prefetchPrice;
     }
     return new Promise((resolve, reject) => {
        let finished = false;
        setTimeout(() => {
            if(!finished){
                finished = true;
                //abort prefetch to avoid weird race conditions
                EtrAPI.services.abortPrefetch();
                resolve({ message: 'max wait exceeded'});
            }
        }, maxWait);

        return EtrAPI.services.hpServices('cupid', priceIds,[],0, true).then((resp) => {
            finished = true;
            resolve(resp)
        }).catch(reject);
    })
}

export default prefetchHPService;